import React from 'react';
import classnames from 'classnames';
import { isEmpty, get, head, find, isUndefined, isBoolean, isEqual } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Typeahead } from 'modules/typeahead';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { singleSelectField as SingleSelectField } from 'ui/views/generic/singleSelectField';
 *
 * // render
 * <SingleSelectField propName='propValue'/>
 */
export const singleSelectField = ( props ) => {

     // get error message (ref)
     const errorMessage = get( props.error, 'message', null );
     const hasError = ! isEmpty( errorMessage );
 
     // dynamic class name
     const widgetClassName = classnames( 'ui-single-select-field', props.className, {
         'ui-single-select-field--error': hasError,
     } );

     let placeholder = ! props.searchable ? getLabel( get( props, 'placeholder', 'Select' ) ) :  get( props, 'placeholder', 'Select' );

     const updateValuesOnChange = get( props, 'config.updateValuesOnChange', false );

     let updatedValuesObj = {};
 
     if ( updateValuesOnChange ) {
 
         updatedValuesObj = {
             selected: !isEmpty( props.value ) ? props.value : [],
             disabled: props.disabled || false
         };
     }
     
    if( ! isEmpty( props.value ) || isBoolean( props.value ) ) {

        const selectedOption = find( props.options, { value: props.value } );

        if( ! isUndefined( selectedOption ) ) {
            placeholder = getLabel( get( selectedOption, 'title', {} ) );
        }

    }
     
    return (
        <div className={ widgetClassName }>
            {/* if mode is not readonly  */}
            { !isEqual( props.mode, 'readonly' ) ? (
                <div className='ui-single-select-field'>
                    {/* label */}
                    <div className='ui-single-select-field__label'>
                        {/* label text */}
                        <div className='ui-single-select-field__label__text'>

                            {/* label */}
                            { props.label ? getLabel( props.label ) : null }

                            {/* required asterisk */}
                            {
                                props.required ? (
                                    <span className='ui-single-select-field__label__asterisk'>*</span>
                                ) : null
                            }
                            
                            
                        </div>
                        
                    </div>

                    {/* select */}
                    <div className='ui-single-select-field__select'>
                        <Typeahead
                            allowFilter= { props.allowFilter }
                            placeholder={ placeholder  }
                            useFocusEvent = { true }
                            useBlurEvent = { false }
                            searchable= { false }
                            options= { props.options }
                            onChange={ ( { selected } ) => props.onChange( {
                                name: props.name,
                                value: head( selected ),
                            } ) }
                            updateOptionsOnChange = { get( props, 'config.updateOptionsOnChange', false ) }
                            updateValueOnSingleOption={ get( props, 'config.updateValueOnSingleOption', false ) }
                            closePopoverOnScrollTrigger={ get( props, 'closePopoverOnScrollTrigger', null ) }
                            disabled={ get( props, 'readonly', false ) }
                            lowerPopoverZIndex={ get( props, 'lowerPopoverZIndex', false ) }
                            updateValuesOnChange = { updateValuesOnChange }
                            { ...updatedValuesObj }
                        />
                    </div>
                </div>
            ) : (
                
                //  if mode is  readonly
                <div className='ui-single-select-field__readonly'>
                    
                    {/* label */}
                    <div className='ui-single-select-field__readonly__label'>
                        { getLabel( props.label ) }
                    </div>

                    {/* input */}
                    <div className='ui-single-select-field__readonly__text'>
                        { getLabel( get( find( props.options, { value: props.value }, {} ), 'title', {} ) ) }
                    </div>
                </div>
            ) }

            {/* error message */}
            {
                hasError ? (
                    <div className='ui-single-select-field__error'>
                        <div className='ui-single-select-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

// set display name
singleSelectField.displayName = 'singleSelectField';

// set default props
singleSelectField.defaultProps = {
    searchable: false,
    allowFilter: false,
};

// prop types
singleSelectField.propTypes = {};
